import { Server } from '../../server/Server';
import Crud , { registerCrudClassProxy, IAsTextResult, IListParams, CrudClassProxy, ISearchTextParams, ISearchTextResult } from '../Crud';

export interface ISharedContentRecord {
    /**
     * Globálisan egyedi azonosító.
     * 
     * Ha új rekordot akarsz létrehozni put() metódussal, akkor hagyd üresen.
     * upsert() hívásnál figyelmen kívül van hagyva az értéke.
     *
     */
    id ?: number;
    /**
     * Rekord létrehozás ideje
     *
     * Trigger állítja be automatikusan a rendszeridőre a tétel létrehozásakor.
     */
    creation_time?: string /*timestamp?*/;
    /**
     * Ki hozta létre
     *
     * NOT NULL -> sys.sec_user ON DELETE noaction
     *
     *
     * Trigger állítja be automatikusan a tétel létrehozásakor, a létrehozó felhasználóra hivatkozik.
     */
    creation_user_id?: number;
    /**
     * Melyik session-ből jött létre
     *
     * Trigger állítja be automatikusan a tétel létrehozásakor, a létrehozáshoz használt munkamenetre hivatkozik.
     */
    creation_session_id?: number|null;
    /**
     * Utolsó módosítás ideje
     *
     * Trigger állítja be automatikusan a rendszeridőre a tétel módosításakor.
     */
    modification_time?: string /*timestamp?*/|null;
    /**
     * Ki módosította utoljára
     *
     * -> sys.sec_user ON DELETE noaction
     *
     *
     * Trigger állítja be automatikusan a tétel módosításakor, a módosító felhasználóra hivatkozik.
     */
    modification_user_id?: number|null;
    /**
     * Melyik session-ből módosították utoljára
     *
     * Trigger állítja be automatikusan a tétel módosításakor, a módosításhoz használt munkamenetre hivatkozik.
     */
    modification_session_id?: number|null;
    /**
     * Aktív
     *
     * Logikai törléshez használt mező.
     */
    is_active?: boolean;
    /**
     * Ki osztotta meg
     *
     * NOT NULL -> sys.sec_user ON DELETE cascade
     *
     */
    shared_by_id?: number;
    /**
     * Mit osztott meg- Táblázat infó
     *
     * NOT NULL -> meta.table_info ON DELETE noaction
     *
     *
     * Ez mondja meg, hogy a megosztott tartalom melyik táblázat rekordjához tartozik.
     */
    table_info_id?: number;
    /**
     * Mit osztott meg - rekord azonosító
     *
     * Ez mondja meg, hogy a megosztott tartalom melyik rekordhoz tartozik.
     */
    rec_id?: number;
    /**
     * Megosztás módja
     *
     * NOT NULL -> usr.share_mode ON DELETE noaction
     *
     */
    share_mode_id?: number;
    /**
     * Név
     */
    title?: string;
    /**
     * Leírás
     */
    description?: string|null;
    /**
     * Megosztás kezdő időpontja
     */
    start_date?: string /*timestamp?*/;
    /**
     * Megosztás befejező időpontja
     */
    end_date?: string /*timestamp?*/|null;
    /**
     * Leadás határideje
     *
     * A leadás határideje csak határidős kiosztásoknál van értelmezve.
     */
    due_date?: string /*timestamp?*/|null;
    /**
     * Futtatások maximális száma
     *
     * Ha meg van adva, akkor a megosztott feladat/feladatsor maximum ennyiszer futtatható. Ennyiszer lehet beküldeni megoldást.
     */
    max_run_count?: number /*integer*/|null;
    /**
     * Beküldés határidő után
     *
     * Lehessen-e beküldeni megoldást a határidő lejárta után.
     */
    send_overdue?: boolean;
    /**
     * Csoportos megoldás
     *
     * A megoldást teljes csoportok küldik be, nem egyének.
     */
    group_solution?: boolean;
    /**
     * Melyik csoportból indították a megosztást
     *
     * -> sys.institute_group ON DELETE cascade
     *
     *
     * Ez csak annyit mutat, hogy a megosztást egy adott tanulócsoportból indították. Semmi köze nincs ahhoz, hogy kikkel van megosztva.
     */
    shared_from_institute_group_id?: number|null;
    /**
     * Max. pontszám
     */
    max_points?: number /*integer*/;
}

/**
 *  usr.shared_content - Megosztott tartalom
 *
 *  Idősoros táblázat, ami az összes tétel összes korábbi verzióját eltárolja.
 */

export default class SharedContentCrud extends Crud<ISharedContentRecord> {
    public static TABLE_INFO_ID = 1316903517;
    public static getSchemaNameForClass() { return 'usr'; }
    public static getTableNameForClass() { return 'shared_content'; }

    public static load: (id: number, aServer ?: Server) => Promise<SharedContentCrud>;
    public static asText: (id: number, includeRecord : boolean, aServer ?: Server) => Promise<IAsTextResult<ISharedContentRecord>>;
    public static list: (params: IListParams, aServer ?: Server) => Promise<ISharedContentRecord[]>;
    public static searchText: (params: ISearchTextParams, aServer ?: Server) => Promise<ISearchTextResult<ISharedContentRecord>[]>;
    public static deleteById: (id: number, aServer ?: Server) => Promise<ISharedContentRecord>;
    public static unDeleteById: (id: number, aServer ?: Server) => Promise<ISharedContentRecord>;
}

/**
 * Class for a class proxy object that can emulate virtual class methods.
 */
export class SharedContentCrudClassProxy extends CrudClassProxy<ISharedContentRecord> {
}
/**
 * A singleton that emulates virtual classmethods of the corresponding Crud class.
 */
export const sharedContentCrudClassProxy = new SharedContentCrudClassProxy(SharedContentCrud);
registerCrudClassProxy(sharedContentCrudClassProxy);
